import { render } from "./AddNewOrderModal.vue?vue&type=template&id=bf37d3c8&ts=true"
import script from "./AddNewOrderModal.vue?vue&type=script&lang=ts"
export * from "./AddNewOrderModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__